/* eslint-disable no-unused-vars */
/* eslint-disable import/prefer-default-export */
import BigNumber from 'bignumber.js';
import { useSetting } from '../../utilities/sharedHooks/settings';
import { BANK_REQUESTS_COINS } from '../Accounts/constants';
import { MAX_LOAN_PERCENTAGE } from './constants';

export const useLoanConditions = (collateralSourceFiatBalance, payoutCurrency) => {
  const [config] = useSetting('crypto_loan_options', [
    'loan_durations',
    'interest_rate_ltv_10',
    'interest_rate_ltv_25',
    'interest_rate_ltv_33',
    'interest_rate_ltv_50',
    'loans_minimum_amount_eur',
    'loans_minimum_amount_usd',
  ]);

  const result = {
    loanDurations: config.loan_durations,
    interest_rate_ltv_10: config.interest_rate_ltv_10,
    interest_rate_ltv_25: config.interest_rate_ltv_25,
    interest_rate_ltv_33: config.interest_rate_ltv_33,
    interest_rate_ltv_50: config.interest_rate_ltv_50,
  };

  let minLoan = config.loans_minimum_amount_eur;
  let maxLoan;
  if (payoutCurrency === BANK_REQUESTS_COINS.EUR || payoutCurrency === BANK_REQUESTS_COINS.EURS) {
    minLoan = config.loans_minimum_amount_eur;
  } else if (
    payoutCurrency === BANK_REQUESTS_COINS.USD ||
    payoutCurrency === BANK_REQUESTS_COINS.USDT ||
    payoutCurrency === BANK_REQUESTS_COINS.USDC
  ) {
    minLoan = config.loans_minimum_amount_usd;
  }

  if (!collateralSourceFiatBalance || !payoutCurrency) {
    maxLoan = minLoan;
    return {
      ...result,
      minLoan,
      maxLoan,
    };
  }

  maxLoan = MAX_LOAN_PERCENTAGE * collateralSourceFiatBalance;
  maxLoan = parseInt(maxLoan, 10);
  maxLoan = new BigNumber(maxLoan).toNumber();
  if (maxLoan < minLoan) {
    maxLoan = minLoan;
    return {
      ...result,
      minLoan,
      maxLoan,
    };
  }

  return {
    ...result,
    minLoan,
    maxLoan,
  };
};

export const useDefaultLoanCollateralWallet = (availableWallets) => {
  const DEFAULT_WALLET = 'btc';

  if (availableWallets.length === 0) return null;
  const defaultWalletIndex = Math.max(availableWallets.indexOf(DEFAULT_WALLET), 0);
  const defaultWallet = availableWallets[defaultWalletIndex];
  if (!defaultWallet) {
    return null;
  }
  return defaultWallet;
};
